const getStoredJwt = () => {
    if (typeof window === "undefined") {
        return null;
    }

    const raw = localStorage.getItem("jwt");

    if (!raw) {
        return null;
    }

    try {
        const parsed = JSON.parse(raw);

        if (typeof parsed === "string") {
            return parsed;
        }

        if (parsed && typeof parsed === "object") {
            return parsed.token ?? null;
        }

        return null;
    } catch (error) {
        // Stored value is already the token string.
        return raw;
    }
}

/** Matches user_types.portal_type */
export const PORTAL_BACKOFFICE = 'backoffice';
export const PORTAL_VENDOR = 'vendor';

export const resolvePortalType = (user = null) => {
    const resolved = user ?? getStoredUser();
    if (!resolved || typeof resolved !== 'object') {
        return null;
    }
    return (
        resolved.portal_type
        ?? resolved.userType?.portal_type
        ?? resolved.user_type?.portal_type
        ?? null
    );
};

export const isBackofficeUser = (user = null) => resolvePortalType(user) === PORTAL_BACKOFFICE;

export const isVendorPortalUser = (user = null) => resolvePortalType(user) === PORTAL_VENDOR;

export const isAuthenticated = () => Boolean(getStoredJwt()) && isBackofficeUser();

export const getJwtToken = () => getStoredJwt();

export const getStoredUser = () => {
    if (typeof window === "undefined") {
        return null;
    }

    const raw = localStorage.getItem("user");

    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch (error) {
        return raw;
    }
}

export const clearAuthSession = () => {
    if (typeof window === "undefined") {
        return;
    }

    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
};

export const redirectToLogin = () => {
    if (typeof window === "undefined") {
        return;
    }

    window.location.replace("/");
};

export const performLogout = (token, apiRootUrl) => {
    clearAuthSession();

    if (token && apiRootUrl) {
        fetch(`${apiRootUrl}/backoffice/logout`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        }).catch(() => {});
    }

    redirectToLogin();
};